import React from "react";

export const HEXToolTipIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="c-hex-tooltip-icon"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 0C4.02955 0 0 4.02955 0 9C0 13.9705 4.02955 18 9 18C13.9705 18 18 13.9705 18 9C18 4.02955 13.9705 0 9 0ZM8.59091 4.09091C8.37391 4.09091 8.16581 4.17711 8.01237 4.33055C7.85893 4.48399 7.77273 4.6921 7.77273 4.90909C7.77273 5.12609 7.85893 5.33419 8.01237 5.48763C8.16581 5.64107 8.37391 5.72727 8.59091 5.72727H9C9.217 5.72727 9.4251 5.64107 9.57854 5.48763C9.73198 5.33419 9.81818 5.12609 9.81818 4.90909C9.81818 4.6921 9.73198 4.48399 9.57854 4.33055C9.4251 4.17711 9.217 4.09091 9 4.09091H8.59091ZM7.36364 7.36364C7.14664 7.36364 6.93853 7.44984 6.78509 7.60328C6.63166 7.75672 6.54545 7.96482 6.54545 8.18182C6.54545 8.39881 6.63166 8.60692 6.78509 8.76036C6.93853 8.9138 7.14664 9 7.36364 9H8.18182V11.4545H7.36364C7.14664 11.4545 6.93853 11.5407 6.78509 11.6942C6.63166 11.8476 6.54545 12.0557 6.54545 12.2727C6.54545 12.4897 6.63166 12.6978 6.78509 12.8513C6.93853 13.0047 7.14664 13.0909 7.36364 13.0909H10.6364C10.8534 13.0909 11.0615 13.0047 11.2149 12.8513C11.3683 12.6978 11.4545 12.4897 11.4545 12.2727C11.4545 12.0557 11.3683 11.8476 11.2149 11.6942C11.0615 11.5407 10.8534 11.4545 10.6364 11.4545H9.81818V8.18182C9.81818 7.96482 9.73198 7.75672 9.57854 7.60328C9.4251 7.44984 9.217 7.36364 9 7.36364H7.36364Z"
        fill="#11387F"
      />
    </svg>
  );
};
